/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Created.ai API
 * OpenAPI spec version: 1
 */

/**
 * The five tiers (3.1), rarest last.
 */
export type Tier = typeof Tier[keyof typeof Tier];


export const Tier = {
  extra: 'extra',
  'supporting-role': 'supporting-role',
  'leading-role': 'leading-role',
  'directors-cut': 'directors-cut',
  'cult-classic': 'cult-classic',
} as const;
